export default __webpack_public_path__ + "static/info-icon-5ddf900c4bbf1316f02e9cf34f9e1c64.svg";